import axiosInstance from '@/services/interceptor.services';

export const useAutoTranslate = () => {
  const runTranslation = async (
    text: string,
    onResult: (code: string, t: string) => void,
    sourceLang: 'fr' | 'nl' | 'en' = 'fr',
  ) => {
    const response = await axiosInstance.post(
      'translation',
      { text, sourceLanguage: sourceLang },
      { headers: { 'Accept-Language': sourceLang } },
    );
    const results: Array<{ code: string; translatedText: string }> =
      response.data?.data ?? [];
    for (const r of results) {
      if (r.code !== sourceLang) onResult(r.code, r.translatedText);
    }
  };

  return { runTranslation };
};
